import React from 'react';
import S from 'StyledBackHeader.js';
import { translation } from 'utilsHelper.js';
import { redirect } from 'helpers/utilsHelper';
import arrowBack from '../../../assets/svg/fuksiarz/arrow-back.svg'

const BackHeader = () => {

    return ( 
        <S.BackHeaderWrapper>
            <S.BackButton onClick={ () => redirect('/konto') }><S.Image as="i" dangerouslySetInnerHTML={{__html: arrowBack}}/>
            </S.BackButton>
            <S.Title>{translation('account_sessionHistory')}</S.Title>
        </S.BackHeaderWrapper>
     );
}
 
export default BackHeader;